import { IconTextGroupCombinedProps } from './types';

const usePresenter = (props: IconTextGroupCombinedProps): IconTextGroupCombinedProps => {
  return props;
};

export default usePresenter;
